import 'css-chunksrc/client/scenes/projectGroupCreation/groupCreationForm/resourcesList/resource/user/styles.scss';export default {
  "resource": "_resource_qh79w_1",
  "user": "_user_qh79w_8",
  "avatar": "_avatar_qh79w_21",
  "name": "_name_qh79w_33",
  "title": "_title_qh79w_42"
};